import { SxProps } from '@mui/material';

export const textareaBox: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
  width: '720px',
  height: 'fit-content',
  gap: '16px',
  position: 'relative',

  '@media screen and (max-width: 1155px)': {
    width: '100%',
  },
};
